import script from "./MainPageCategoriesBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPageCategoriesBanner.vue?vue&type=script&setup=true&lang=ts"

import "./MainPageCategoriesBanner.vue?vue&type=style&index=0&id=8c5cce92&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c5cce92"]])

export default __exports__